var exports = {
  "qM": "AttachmentSingleMedia.module__relativeWrapper___TTNmdj",
  "u7": "AttachmentSingleMedia.module__singleMediaContainer___TTNmdj",
};

module.exports = exports;
